var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},[React.createElement("rect",{"fill":"transparent","stroke":"currentColor","strokeWidth":"2","x":"1","y":"1","width":"34","height":"34","rx":"17","key":0}),React.createElement("polygon",{"points":"27 19.2735849 19.3034483 19.2735849 16.6965517 19.2735849 9 19.2735849 9 16.7688679 16.6965517 16.7688679 19.3034483 16.7688679 27 16.7688679","key":1})]));
}

Minus.defaultProps = {"width":"36px","height":"36px","viewBox":"0 0 36 36","version":"1.1"};

module.exports = Minus;

Minus.default = Minus;
